<template>
  <v-row>
    <SaveEmailTemplateDialog v-model="isSaveEmailTemplateDialogVisible"
                             @onSaveEmailTemplate="saveEmailTemplate"
                             @onUpdateEmailTemplate="updateEmailTemplate" />

    <SaveTemplateWarningDialog v-model="isSaveTemplateWarningDialogVisible"
                               @continueWithoutSaving="exportHtml()"
                               @saveTemplate="openSaveEmailTemplateDialog(true)"/>

    <v-col cols="12">
      <div class="d-flex align-center justify-space-between pb-5"
           style="border-radius: 6px">
        <h3 class="kbDarkBlueText--text">
          {{ $t('general.createHtmlTemplate') }}
        </h3>

        <ButtonCopyCustomizeField />
      </div>
      <div>
        <email-editor ref="emailEditor" @load="changeVisualizedEmailTemplate(sample)"/>
      </div>
    </v-col>

    <v-col cols="12" class="d-flex align-center justify-space-between">
      <v-btn color="mainButtons"
             @click="updateStep(2)"
             outlined>
        <v-icon dark>keyboard_arrow_left</v-icon>
        <span class="hidden-xs-only">{{ $t('general.goBack') }}</span>
      </v-btn>
      <v-btn color="mainButtons"
             dark
             @click="openSaveEmailTemplateDialog()">
        {{ $t('general.saveTemplate') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { EventBus } from '@/eventBus'
import { EmailEditor } from 'vue-email-editor'
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import sample from '@/assets/sample.json'
import ButtonCopyCustomizeField from '@/components/widgets/EmailTemplates/ButtonCopyCustomizeField'
import SaveEmailTemplateDialog from '@/components/widgets/EmailTemplates/SaveEmailTemplateDialog'
import SaveTemplateWarningDialog from '@/components/widgets/EmailTemplates/SaveTemplateWarningDialog'
export default {
  components: { ButtonCopyCustomizeField, SaveTemplateWarningDialog, EmailEditor, SaveEmailTemplateDialog },
  computed: {
    ...mapState({
      selectedTemplate: state => state.campaigns.selectTemplate
    })
  },
  created () {
    this.hearExternalEvents()
  },
  data () {
    return {
      exportHtmlAfterSave: false,
      htmlToExport: '',
      isSaveEmailTemplateDialogVisible: false,
      isSaveTemplateWarningDialogVisible: false,
      sample
    }
  },
  methods: {
    changeVisualizedEmailTemplate (emailTemplate) {
      if (this.$refs.emailEditor) {
        this.$refs.emailEditor.editor.loadDesign(emailTemplate)
      }
    },
    exportHtml () {
      this.$emit('onHtmlExported', this.htmlToExport)
      this.htmlToExport = ''
    },
    async getTemplateById () {
      try {
        const response = await this.$store.dispatch('getTemplateById', this.selectedTemplate._id)
        this.changeVisualizedEmailTemplate(response.template.template)
      } catch (e) {
        notifications.error(e)
      }
    },
    hearExternalEvents () {
      EventBus.$on('onExportHtml', () => { this.onExportHtml() })
      EventBus.$on(
        'onUpdateEmailTemplate',
        emailTemplate => { this.updateEmailTemplate(emailTemplate) }
      )
    },
    onEmailEditorLoaded () {
      if (this.selectedTemplate && typeof this.selectedTemplate === 'object' && this.selectedTemplate._id) {
        this.getTemplateById()
      } else {
        this.changeVisualizedEmailTemplate(sample)
      }
    },
    onExportHtml () {
      this.$refs.emailEditor.editor.exportHtml(
        (data) => {
          this.htmlToExport = data.html
          if (!this.wasTemplateSavedOrUpdated) {
            this.openSaveTemplateWarningDialog()
          } else {
            this.exportHtml()
          }
        }
      )
    },
    openSaveEmailTemplateDialog (exportHtmlAfterSave = false) {
      this.exportHtmlAfterSave = exportHtmlAfterSave
      this.isSaveEmailTemplateDialogVisible = true
    },
    openSaveTemplateWarningDialog () {
      this.isSaveTemplateWarningDialogVisible = true
    },
    onSaveOrUpdateTemplateStatusChange () {
      this.$emit('onSaveOrUpdateTemplateStatusChange')
    },
    saveEmailTemplate (templateName) {
      this.$refs.emailEditor.editor.saveDesign(
        async (template) => {
          try {
            const response = await this.$store.dispatch('saveTemplate', { template, name: templateName })
            notifications.success(this.$t('general.templateSuccessfullySaved'))
            this.setTemplateIdAfterSavingTemplate(response.template.id)
            this.onSaveOrUpdateTemplateStatusChange()
            if (this.exportHtmlAfterSave) {
              this.onExportHtml()
            }
          } catch (e) {
            console.error(e)
          }
        }
      )
    },
    setTemplateIdAfterSavingTemplate (templateId) {
      this.$emit('setTemplateIdAfterSavingTemplate', templateId)
    },
    updateEmailTemplate (templateId) {
      this.$refs.emailEditor.editor.saveDesign(
        async (template) => {
          try {
            await this.$store.dispatch('updateTemplate', { template, templateId })
            notifications.success(this.$t('general.templateSuccessfullyUpdated'))
            this.onSaveOrUpdateTemplateStatusChange()
            if (this.exportHtmlAfterSave) {
              this.onExportHtml()
            }
          } catch (e) {
            console.error(e)
          }
        }
      )
    },
    updateStep (step) {
      this.$emit('onStepChange', step)
    }
  },
  props: {
    wasTemplateSavedOrUpdated: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedTemplate () {
      this.onEmailEditorLoaded()
    }
  }
}
</script>

<style scoped>
  ::v-deep iframe {
    height: 80vh!important;
  }

  @media only screen and (min-width: 1264px) {
    ::v-deep iframe {
      height: 500px!important;
    }
  }

  @media only screen and (min-width: 1904px) {
    ::v-deep iframe {
      height: 65vh!important;
    }
  }
</style>
